$(function () {
  let filterForm = $('#filter_form');
  filterForm.on('change', function () {
    $('#go-to-pay-button').prop('disabled', true);
  });
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/buy_more_leads.js